import { addTraits } from 'src/api';

export const getFIs = state =>
  addTraits(state.financialInstitution.financialInstitutions);

export const getFISettings = state =>
  addTraits(state.financialInstitution.fiSettings);

export const getFIPeople = state =>
  addTraits(state.financialInstitution.people);

export const getFIDocumentTypes = state =>
  addTraits(state.financialInstitution.documentTypes);

export const getFIConsentTypes = state =>
  addTraits(state.financialInstitution.consentTypes);
